const SHOPPING_CART_ENDPOINTS = {
  GET: 'shopping-cart',
  ADD_GIFTCARD: (id: string) => `shopping-cart/service-provider-items/${id}`,
  ADD_BUNDLE: (id: string) => `shopping-cart/bundles/${id}`,
  DELETE_ITEM: (id: string) => `shopping-cart/items/${id}`,
  CROSS_SELL_RECOMMENDATIONS: 'shopping-cart/cross-sell-recommendations',
  BUY: 'shopping-cart/buy',
  BUY_BY_WALLET: 'shopping-cart/buy/by-wallet',
} as const;

export default SHOPPING_CART_ENDPOINTS;
